export default __webpack_public_path__ + "static/image-66-86f3b49e1730c1de9fb87e1d72e37897.png";